// ErrorBoundary.tsx
import React from 'react';
import { ErrorScreen } from './ErrorScreen'; // your friendly UI

class ErrorBoundary extends React.Component<any, { hasError: boolean; error: any }> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: any) {
        return { hasError: true, error };
    }

    componentDidCatch(error: any, errorInfo: any) {
        // ✅ log to Sentry / console / etc.
        if (process.env.NODE_ENV !== 'production') {
            console.error('Caught by error boundary:', error, errorInfo);
        } else {
            // send to Sentry / LogRocket / your dev's tears bucket
        }
    }

    render() {
        if (this.state.hasError) {
            return <ErrorScreen error={this.state.error} />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
